/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.22.0
 */

import { EConnectionStatusId } from '@/main/pages/PageAccountInfo/types/pageAccountInfoGeneralTypes';
import type {
  IAccountDeliveryInfoData,
  IAccountInfoDeliveryData,
} from '@/main/pages/PageAccountInfo/types/pageAccountInfoTypes';

type TSetEdmDisabled = (
  isServiceUser: boolean,
  isCoordinator: boolean,
  isCustomDocsManage: boolean,
  formValues: IAccountInfoDeliveryData,
  meta: IAccountDeliveryInfoData,
) => boolean;

export const setEdmDisabled: TSetEdmDisabled = (
  isServiceUser,
  isCoordinator,
  isCustomDocsManage,
  formValues,
  meta,
) => {
  const { usePost: formUsePost } = formValues;

  if (!!meta.edm) {
    const { connections } = meta.edm;
    // 1 check: coordinator role
    if (!(isCoordinator || isCustomDocsManage) || isServiceUser) {
      return true;
      // 2 check: post or courier delivery (from formValues because initial values got from deliveryMeta)
    } else if (formUsePost) {
      return true;
      // 3 & 4 check: edm connection in CONNECTED or DISCONNECT_IN_PROGRESS status
    } else if (!connections || !connections.length) {
      return true;
    } else if (!!connections && !!connections.length) {
      return !connections.some(
        (item) =>
          item.statusId === EConnectionStatusId.CONNECTED ||
          item.statusId === EConnectionStatusId.DISCONNECT_IN_PROGRESS,
      );
    }
    return false;
  }
  return true;
};

type TSetConnectButtonDisable = (
  isChangeMode: boolean,
  isInitialOperator: boolean,
  isShowContactFields: boolean,
  isValid: boolean,
  isServiceUser: boolean,
) => boolean;

export const setConnectButtonDisable: TSetConnectButtonDisable = (
  isChangeMode,
  isInitialOperator,
  isShowContactFields,
  isValid,
  isServiceUser,
) => {
  if (isServiceUser) {
    return true;
  }
  if (isChangeMode) {
    return isInitialOperator ? true : !isValid;
  }

  if (!isShowContactFields) {
    return isServiceUser;
  }

  return !isValid;
};
